export const environment = {
  production: true,
  apiURL: 'https://ltl-service.staging.tltgrp.com/api',
  graphQLURL: 'https://loadtracker.staging.tltgrp.com/api/graphql',
  ablyKey: 'CBunZA.JcfeWg:nqgaR2qUXbD9dWCqP90OyCLnDdHrqRddzfKt86EJ814',
  links: {
    nexus: 'https://nexus.staging.tltgrp.com/',
    itracker: 'https://itracker.staging.tltgrp.com/',
    reporting: 'https://reporting.staging.tltgrp.com/',
  },
  sso: {
    url: 'https://sso.staging.tltgrp.com/realms/master',
    clientId: '',
  },
  mapbox: {
    accessToken:
      'pk.eyJ1IjoidGlsdGdyb3VwIiwiYSI6ImNsbHh2dHl5bjJncnUza3RoZ2lkeHFkOHQifQ.gBgDAIq9VeKettrgqxdhdA',
    legacyMapBoxStyleUrl: 'mapbox://styles/tiltgroup/cm84dtnms003001s30mcia9y2',
    darkMapBoxStyleUrl: 'mapbox://styles/tiltgroup/cmrbsfvjn000501s720un0izv',
  },
  graphQLEnumsURL: `https://loadtracker.staging.tltgrp.com/api/graphql-enums.json`,
  releaseNotesConfig: {
    project_key: '',
    base_url: 'https://release-manager.staging.tltgrp.com',
    token_mode: 'external',
  },
};
